import btnArrowLeft from "../../assets/images/btn-left.png";
import btnArrowRight from "../../assets/images/btn-right.png";

interface ArrowSelectorProps {
  label: string;
  value: string;
  options: { value: string; label: string }[];
  onChange: (value: string) => void;
  highlightedWord?: string;
  disabled?: boolean;
}

export const ArrowSelector: React.FC<ArrowSelectorProps> = ({
  label,
  value,
  options,
  onChange,
  highlightedWord,
  disabled,
}) => {
  const currentIndex = options.findIndex((opt) => opt.value === value);

  const handlePrev = () => {
    if (disabled) return;
    const newIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
    onChange(options[newIndex].value);
  };

  const handleNext = () => {
    if (disabled) return;
    const newIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
    onChange(options[newIndex].value);
  };

  const currentLabel = options[currentIndex]?.label || value;

  return (
    <div className="flex items-center justify-between py-2 border-[1px] rounded-sm border-white/10 bg-white/5 px-3">
      <p className="text-[14px] gilroy-font text-white/50 flex flex-wrap gap-1">
        {label?.split(" ")?.map((word, i) => (
          <span
            key={i}
            className={highlightedWord === word ? "text-white" : ""}
          >
            {word}
          </span>
        ))}
      </p>
      <div className="flex items-center gap-2">
        <button
          onClick={handlePrev}
          disabled={disabled}
          className={`p-1 rounded transition-all duration-200 ${
            disabled
              ? "opacity-30 cursor-not-allowed"
              : "hover:bg-gray-700 text-gray-400 hover:text-white active:scale-75"
          }`}
        >
          <img src={btnArrowLeft} alt="test" className="w-full h-full" />
        </button>

        <div className="min-w-[85px] text-center">
          <span className="text-gray-200 text-[15px]  transition-all duration-300">
            {currentLabel}
          </span>
        </div>

        <button
          onClick={handleNext}
          disabled={disabled}
          className={`p-1 rounded transition-all duration-200 ${
            disabled
              ? "opacity-30 cursor-not-allowed"
              : "hover:bg-gray-700 text-gray-400 hover:text-white active:scale-75"
          }`}
        >
          <img src={btnArrowRight} alt="right" className="w-full h-full" />
        </button>
      </div>
    </div>
  );
};
export default ArrowSelector;
